import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  z-index: 1000;
`;

export const SelectedLanguage = styled.button`
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.98);
  border: 2px solid rgba(255, 255, 255, 0.5);
  border-radius: 50%;
  padding: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(10px);
  width: 48px;
  height: 48px;
  justify-content: center;

  &:hover {
    background: rgba(255, 255, 255, 1);
    transform: translateY(-2px) scale(1.05);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
    border-color: rgba(76, 175, 80, 0.5);
  }

  &:active {
    transform: translateY(0) scale(1);
  }
`;

export const Flag = styled.img`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  object-fit: cover;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const DropdownContainer = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background: rgba(255, 255, 255, 0.98);
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(15px);
  min-width: 180px;
  overflow: hidden;
  z-index: 1001;
  border: 1px solid rgba(255, 255, 255, 0.3);

  &::before {
    content: "";
    position: absolute;
    top: -6px;
    right: 18px;
    width: 12px;
    height: 12px;
    background: rgba(255, 255, 255, 0.98);
    transform: rotate(45deg);
    border-left: 1px solid rgba(255, 255, 255, 0.3);
    border-top: 1px solid rgba(255, 255, 255, 0.3);
  }
`;

export const LanguageOption = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 16px 20px;
  border: none;
  background: ${(props) =>
    props.$isActive ? "rgba(76, 175, 80, 0.15)" : "transparent"};
  cursor: pointer;
  transition: all 0.2s ease;
  gap: 12px;
  position: relative;

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  &:not(:last-child) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  }

  ${(props) =>
    props.$isActive &&
    `
    &::after {
      content: '✓';
      position: absolute;
      right: 16px;
      color: #4CAF50;
      font-weight: bold;
      font-size: 14px;
    }
  `}
`;

export const LanguageText = styled.span`
  color: #2c3e50;
  font-size: 14px;
  font-weight: 500;
  flex: 1;
  text-align: left;
`;
